import { SubMenu, SubMenuItem} from "../../../common/components/SubMenu.jsx";

import CalendarItem from "../../../common/components/CalendarItem.jsx";
import {Localization} from "../../../common/util/localization.jsx";
import PropTypes from "prop-types";
import React from "react";

import {iconTypes} from "../../../common/components/Icon.jsx";
import {scssVariables } from "../../../common/util/config.jsx";


class CalendarCard extends React.Component {
    constructor(props){
        super(props);

        this.getDropDownDateStyle = this.getDropDownDateStyle.bind(this);
    }
    getDropDownDateStyle() {
        const {
            width,
            deviceType,
        } = this.props;

        //calender max current max size is 450
        return (deviceType==="xs" && {
            width: Math.min(450, Math.max(parseInt(scssVariables.minDeviceWidth),width)),
        }) || (deviceType==="sm" && {
            width: Math.min(450,width-parseInt(scssVariables.shoppingCartWidthTiny)+parseInt(scssVariables.cardMargin)+parseInt(scssVariables.menuHeight)),
        } || {
            width: 450,
        });
    }

    render(){
        const {
            deviceType,
            deliveryDates,
            activeOrder,
            setDropDown,
            localization,
            newSeasonDistrDates,
            setActiveOrder,
            width,
            history,
        } = this.props;

        return (
            <div className="card-default calendar-card">
                <div className="flex-container">
                    <SubMenu border={false} style={{height: "75px"}}>
                        <React.Fragment>
                            <SubMenuItem side="left-borderless" iconType={newSeasonDistrDates.length>0? iconTypes.calendarWarning : iconTypes.calender} setDropDown={setDropDown} dropDownStyle={this.getDropDownDateStyle()} dropDownShiftLeft={deviceType!=="xs"} isDroppedDown={true} below={true} dropDownChildren={(                            
                                <CalendarItem text= {localization.text("dashboard","calendar")} deviceType={deviceType} activeOrder={activeOrder} width={width} setDropDown={setDropDown} localization={localization} deliveryDates={deliveryDates} setActiveOrder={setActiveOrder} history={history} newSeasonDistrDates = {newSeasonDistrDates}/>
                            )}/>
                            <div className="calendar-text">
                                {localization.text("dashboard","calendar")}
                            </div>   
                        </React.Fragment>
                    </SubMenu>           
                </div>
            </div>
        );
    }
}
CalendarCard.propTypes = {
    width: PropTypes.number,
    deviceType: PropTypes.string.isRequired,
    deliveryDates: PropTypes.array,
    setDropDown: PropTypes.func,
    activeOrder: PropTypes.object.isRequired, 
    localization: Localization.propTypes.isRequired,
    setActiveOrder: PropTypes.func,
    history: PropTypes.object.isRequired,
    newSeasonDistrDates : PropTypes.array.isRequired,
};
export default CalendarCard;